import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-login-informations',
    templateUrl: './login-informations.component.html',
    styleUrls: ['./login-informations.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginInformationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
